import styled, { css } from 'styled-components'

export const SC_ModalBackdrop = styled.div.attrs(props => ({
  className: "modal-backdrop show fade in",
}))`
	
`

export const SC_Modal = styled.div.attrs(props => ({
  className: "modal",
  tabindex: "-1",
  role: "dialog"
}))`
  ${props => props.modalOpen ? 
  `display: block;` 
  : null }
`

export const SC_ModalDialog = styled.div.attrs(props => ({
  className: "modal-dialog",
  role: "document"
}))`

`

export const SC_ModalContent = styled.div.attrs(props => ({
  className: "modal-content",
}))`

`

export const SC_ModalHeader = styled.div.attrs(props => ({
  className: "modal-header",
}))`

`

export const SC_ModalBody = styled.div.attrs(props => ({
  className: "modal-body",
}))`

`